

















































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { ListModel } from "@/shared/models/listModel";
import { RatePlanAccUnitType } from "@/shared/models/accomodationUnitTypeViewModel";
import NumericInput from "@/components/misc/NumericInput.vue";
import { Notification } from "../../store/modules/notifications";
import { formatLocaleNumber } from "@/components/numbers/numberFormatUtils";
import FormDescription from "@/components/misc/FormDescription.vue";
import {
  RatePlanModel,
  RatePlanTypeFilterEnum,
} from "@/shared/models/ratePlanModel";
import handleBrokenRuleAdapter from "@/shared/handleBrokenRuleAdapter";
import * as _ from "lodash";

export interface RatePlanGroup {
  ratePlanId: number;
  ratePlanName: string;
  ratePlanUnitTypes: RatePlanAccUnitType[];
}

@Component({
  components: {
    NumericInput,
    FormDescription,
  },
})
export default class AccomodationUnitTypeRatePlanOverrides extends Vue {
  @Prop({ default: 0 }) accUnitTypeId?: number;
  @Prop({ default: false }) accUnitTypeShownOnBE?: boolean;

  loading = true;
  saving = false;
  firstTimeLoad = true;
  ratePlanSelectOpen = false;

  ratePlans: RatePlanGroup[] = [];
  allRatePlans: RatePlanModel[] = [];

  formatLocaleNumber = formatLocaleNumber;
  @Getter("language/language") language?: string;
  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  @Getter("appParams/showPAXSuffixInRatePlanName")
  showPAXSuffixInRatePlanName?: boolean;
  @Getter("appParams/showLOSSuffixInRatePlanName")
  showLOSSuffixInRatePlanName?: boolean;

  filters = {
    ratePlanType: RatePlanTypeFilterEnum.All,
  };

  get availableRatePlans() {
    const availableRatePlans = this.allRatePlans.filter((x) => {
      return !this.ratePlans.find((y) => {
        return y.ratePlanId === x.id;
      });
    });
    return availableRatePlans.filter(
      (x) =>
        !x.isDerived ||
        (x.isDerived &&
          this.ratePlans.some((y) => y.ratePlanId === x.parentRatePlanId))
    );
  }

  @Watch("accUnitTypeId", { immediate: true })
  load() {
    if (!this.accUnitTypeId) return;

    this.axios
      .get<ListModel<RatePlanAccUnitType>>(
        `/AccomodationUnitTypes/${this.accUnitTypeId}/ratePlanMappings`
      )
      .then((res) => {
        this.ratePlans = [];
        const grouped = _.groupBy(res.data.result, (x) => x.ratePlanId);
        for (const key in grouped) {
          const group = grouped[key];
          this.ratePlans.push({
            ratePlanId: group[0].ratePlanId,
            ratePlanName: group[0].ratePlanName,
            ratePlanUnitTypes: group.sort((a, b) =>
              a.minPersons - b.minPersons === 0
                ? a.minStay - b.minStay
                : a.minPersons - b.minPersons
            ),
          });
        }
      })
      .finally(() => {
        this.loading = false;
        this.saving = false;
      });

    if (this.firstTimeLoad) {
      this.loading = true;
      this.firstTimeLoad = false;
      Vue.axios
        .get<ListModel<RatePlanModel>>("RatePlans/", {
          params: this.filters,
        })
        .then((res) => {
          this.allRatePlans = res.data.result;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  ratePlanIdToAdd: number | null = null;
  addRatePlan() {
    this.saving = true;
    this.axios
      .post(
        `/AccomodationUnitTypes/${this.accUnitTypeId}/ratePlans/${this.ratePlanIdToAdd}`
      )
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("RatePlan.SaveSuccess"),
          timeout: 5000,
        });
        this.ratePlanIdToAdd = null;
        this.ratePlanSelectOpen = false;
      })
      .finally(() => {
        this.load();
        this.saving = false;
      });
  }

  updateRatePlan(plan: RatePlanAccUnitType) {
    this.saving = true;
    this.axios
      .put(
        `/AccomodationUnitTypes/${this.accUnitTypeId}/ratePlans/${plan.id}`,
        {
          id: plan.id,
          isAvailableViaBookingEngine: plan.isAvailableViaBookingEngine,
          bookingEnginePriceOffset: plan.isAvailableViaBookingEngine
            ? plan.bookingEnginePriceOffset
            : null,
        }
      )
      .finally(() => this.load());
  }

  deleteRatePlan(group: RatePlanGroup) {
    this.$store.dispatch("showNotification", {
      color: "warning",
      message: this.$t("AccommodationUnitType.DeleteRatePlanConfirmation", {
        value: group.ratePlanName,
      }),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deleteRatePlanConfirm(group.ratePlanId, []);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }

  deleteRatePlanConfirm(id: number, overrides: string[]) {
    const handleCodes = ["RatePlan.DeleteValidation.OtaSync"];
    const adapter = handleBrokenRuleAdapter(this.axios, handleCodes);

    // prettier-ignore
    const formatBrokenRuleNames = (x: string[]) => x
      .map((h) => this.$t(h).toString())
      .map((th) => th.endsWith(".") ? th : th + ".")
      .join(" ");

    const isOverriding = overrides.length !== 0;

    this.saving = true;
    this.axios
      .delete(`/AccomodationUnitTypes/${this.accUnitTypeId}/ratePlans/${id}`, {
        data: { overrideRules: overrides },
        adapter: isOverriding ? undefined : adapter,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("RatePlan.DeleteSuccess"),
          timeout: 5000,
        } as Notification);
      })
      .catch((x) => {
        if (x && x.isHandleBrokenRuleResult && !isOverriding) {
          this.$store.dispatch("showNotification", {
            color: "warning",
            message:
              // prettier-ignore
              `${formatBrokenRuleNames(x.handled)} ${this.$t("Do you wish to continue anyway?")}`,
            timeout: 30000,
            actions: [
              {
                text: this.$t("Yes"),
                fun: () => {
                  this.deleteRatePlanConfirm(id, x.handled);
                  return true;
                },
              },
              { text: this.$t("Cancel"), fun: () => true },
            ],
          } as Notification);
        } else {
          this.$store.dispatch("showNotification", {
            color: "error",
            message: `${formatBrokenRuleNames(x.unhandled)}`,
            timeout: 5000,
          } as Notification);
        }
      })
      .finally(() => this.load());
  }

  getRatePlanFullName(ratePlan: RatePlanAccUnitType) {
    let paxSuffix = "";
    let losSuffix = "";

    if (this.showPAXSuffixInRatePlanName) {
      paxSuffix =
        ratePlan.minPersons === ratePlan.maxPersons
          ? `, ${ratePlan.minPersons} pax`
          : `, ${ratePlan.minPersons}-${ratePlan.maxPersons} pax`;
    }

    if (this.showLOSSuffixInRatePlanName) {
      losSuffix =
        ratePlan.maxStay === 0
          ? `, ${ratePlan.minStay}+ LOS`
          : ratePlan.minStay === ratePlan.maxStay
          ? `, ${ratePlan.minStay} LOS`
          : `, ${ratePlan.minStay}-${ratePlan.maxStay} LOS`;
    }

    return ratePlan.ratePlanName + paxSuffix + losSuffix;
  }
}
